import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="mb-14">
          <p className="text-xs font-label font-light text-foreground-400 uppercase tracking-[0.2em] mb-3">
            Browse All Categories
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-[1.1]">
            Every Category
            <br />
            You Need
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block p-8 bg-background-50 rounded-xl hover:bg-background-200/40 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${cat.icon} text-3xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-label font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Browse Now
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}